import axios from "axios";
import { config } from "./config";

const instance = axios.create({
  baseURL: "https://keeper-2de7a-default-rtdb.firebaseio.com/",
});

export const idomDBInstance = axios.create({
  baseURL: config.apiurl,
});

export default instance;
